export type { StatusIndicatorProps } from "./status-indicator";
export { StatusIndicator } from "./status-indicator";
